import React from 'react'
import styled, { css } from 'styled-components'
import moment from 'moment'
import { withNamespaces } from 'react-i18next'

const ticketPillColors = {
  0: 'transparent',
  1: 'rgba(235, 152, 78, 0.8)',
  2: 'rgba(230, 126, 34, 0.8)',
  active: '#2E5BFF',
  escalated: 'rgba(231, 76, 60, 0.8)'
}

const ItemWrapper = styled.div`
  height: 97px;
  padding: 13px 18px 9px 18px;

  transition: background-color 0.2s, border 0.2s;

  border-bottom: 1px solid #eeeff1;
  border-left: 2px solid
    ${(props) => (props.active ? '#2E5BFF' : 'transparent')};

  background-color: ${(props) => (props.active ? '#F4FAFF' : '#fff')};

  ${(props) =>
    props.feedback &&
    css`
      background-color: rgba(174, 214, 241, 0.1);
    `};

  cursor: pointer;

  :hover {
    background-color: #f4faff;
  }
`

const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;

  div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .info_row {
    display: flex;
    justify-content: space-between;

    div {
      width: 50%;

      :nth-child(1) {
        color: #2e384d;
      }

      :nth-child(2) {
        text-align: right;
        color: #b0bac9;
      }
    }
  }
`

const StyledTicketTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ColoredPill = styled.div`
  border-radius: 8px;
  background-color: ${(props) => props.bgColor};

  color: #fff;
  font-size: 9px;
  padding: 2px 4px;

  margin-left: 5px;
`

const StyledSubject = styled.div`
  font-size: 15px;
  color: #2e384d;
  flex: 1;
`

const onClickHandler = (isActive, fetchInteraction, interaction_id) =>
  isActive ? null : () => fetchInteraction(interaction_id)

const InteractionListItem = ({
  t,
  selectedInteractionId,
  entity,
  style,
  fetchInteraction
}) => {
  const {
    subject,
    status,
    interaction_id,
    number,
    update_date,
    product_name,
    escalated,
    feedback_required,
    severity
  } = entity

  const isActive = selectedInteractionId === interaction_id

  const ticketPillColor = escalated
    ? ticketPillColors.escalated
    : ticketPillColors[severity]

  return (
    <ItemWrapper
      onClick={onClickHandler(isActive, fetchInteraction, interaction_id)}
      active={isActive}
      style={style}
      feedback={feedback_required}
    >
      <StyledItem>
        <StyledTicketTop>
          <StyledSubject>{subject}</StyledSubject>
          {escalated && (
            <ColoredPill bgColor={ticketPillColor}>Escalated</ColoredPill>
          )}
          {!escalated && severity !== 0 && (
            <ColoredPill bgColor={ticketPillColor}>
              {t(`severity:${severity}`)}
            </ColoredPill>
          )}
        </StyledTicketTop>
        <div className="info_row">
          <div>{number}</div>
          <div>{moment(update_date).format('DD/MM/YY - HH:mm')}</div>
        </div>

        <div className="info_row">
          <div>{status}</div>
          <div>{product_name}</div>
        </div>
      </StyledItem>
    </ItemWrapper>
  )
}

export default withNamespaces()(InteractionListItem)
